import { jsx as _jsx } from "react/jsx-runtime";
const SvgStreamPlatformTwitchFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icons",
		children: /* @__PURE__ */ _jsx("g", {
			id: "StreamingPlatform",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Platform=Twitch_filled",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M26 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V24C4 24.5304 4.21071 25.0391 4.58579 25.4142C4.96086 25.7893 5.46957 26 6 26H8V30C7.99993 30.1901 8.05403 30.3762 8.15597 30.5367C8.25791 30.6971 8.40346 30.8252 8.57557 30.9058C8.74767 30.9865 8.93921 31.0165 9.12773 30.9922C9.31625 30.9679 9.49395 30.8904 9.64 30.7687L15.3625 26H20.6375C21.1057 26.0002 21.5591 25.836 21.9188 25.5362L27.28 21.0675C27.5057 20.8803 27.6873 20.6455 27.8118 20.3799C27.9363 20.1143 28.0005 19.8245 28 19.5312V6C28 5.46957 27.7893 4.96086 27.4142 4.58579C27.0391 4.21071 26.5304 4 26 4ZM16 17C16 17.2652 15.8946 17.5196 15.7071 17.7071C15.5196 17.8946 15.2652 18 15 18C14.7348 18 14.4804 17.8946 14.2929 17.7071C14.1054 17.5196 14 17.2652 14 17V11C14 10.7348 14.1054 10.4804 14.2929 10.2929C14.4804 10.1054 14.7348 10 15 10C15.2652 10 15.5196 10.1054 15.7071 10.2929C15.8946 10.4804 16 10.7348 16 11V17ZM22 17C22 17.2652 21.8946 17.5196 21.7071 17.7071C21.5196 17.8946 21.2652 18 21 18C20.7348 18 20.4804 17.8946 20.2929 17.7071C20.1054 17.5196 20 17.2652 20 17V11C20 10.7348 20.1054 10.4804 20.2929 10.2929C20.4804 10.1054 20.7348 10 21 10C21.2652 10 21.5196 10.1054 21.7071 10.2929C21.8946 10.4804 22 10.7348 22 11V17Z",
					fill: "#9147FF"
				})
			})
		})
	})
});
export default SvgStreamPlatformTwitchFilled;
